import moment from 'moment'
import { MomentInput } from 'moment'

// Duplicated in app/eworkflows/scheduling/schedule/appointment/get-selected-time.ts
function getSelectedTime(momentInput: MomentInput) {
  return moment.utc(momentInput).toDate().getTime() || 0
}

export default getSelectedTime
